import customHeaders, { getSpace } from "../../../common/headers";
import { KonstantinMasterHttps, KonstantinMasterHttp } from "../../../fetchUrls";
import { ModalComponent } from "../ModalComponent/ModalComponent";
import { useState, useEffect, useRef } from 'react';
import useGeneralStore from "../../../store/general";
import { TableTop5 } from "../../TableTop5/TableTop5";
import { useResponseHandler } from "../../../common/auth";
import './ModalUnansweredFeedback.scss'

const ModalUnansweredFeedback = ({
    setIsModal, setIsAllUnanswered,
    tableBody, totalCounter = { feedbacks: 0, questions: 0 },
    date
}) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const [fetchedData, setFetchedData] = useState([])
    const [loading, setLoading] = useState(false)
    const paginatorRef = useRef()

    const fetchTableData = (params, resetPage = false, allUnswered = true) => {
        let sort;
        let filtersParam = [];

        if (params) {
            [sort, filtersParam] = params
        }
        setLoading(true)
        setFetchedData([])
        let url
        if (!window.location.hostname.match('localhost')) {
            if (allUnswered) {
                url = `${KonstantinMasterHttps}/feedbacks-and-questions/tables/v2/unanswered-feedbacks-questions?order_param_direction=ASC`
            }
        } else {
            if (allUnswered) {
                url = `${KonstantinMasterHttp}/feedbacks-and-questions/tables/v2/unanswered-feedbacks-questions?order_param_direction=ASC`
            }
        }

        const [date_from, date_to] = date
        const body = JSON.stringify({
            page: paginatorRef.current?.page,
            limit: 5,
            filters: filtersParam,
            // api_id_list: ['all'],
            // category_id_list: ['all'],
            // brand_id_list: ['all'],
            // product_valuation_list: ['all'],
            // status: 'Все',
            // date_from: msToLocalDate(date_from),
            // date_to: msToLocalDate(date_to)
        })


        fetch(url, { body, method: 'POST', headers })
            .then(handleTableResponse)
            .then(json => setFetchedData(json))
            .catch(handleRequestError)
            .finally(() => setLoading(false))
    }


    useEffect(() => {
        fetchTableData([], true, true)
    }, [date, tableBody, selectedSpace])

    return (
        <ModalComponent
            title="Колличество неотвеченных отзывов и вопросов"
            onClose={(e) => {
                setIsModal(false)
                setIsAllUnanswered(false)
            }}
            style={{
                height: 'auto',
                maxWidth: '800px'
            }}
            child={
                <div className='modal-unanswered-Feedbackmodal'>
                    <TableTop5
                        title={<>Всего неотвеченных отзывов <b>{totalCounter?.feedbacks}</b> и вопросов <b>{totalCounter?.questions}</b></>}
                        data={fetchedData}
                        height={'480px'}
                        loading={loading}
                    />
                </div>}
        />
    )
}

export { ModalUnansweredFeedback }